import { convertNumberToWords, numberSeparate } from "../../utils";

export const ConvertCurrency = ({ price }) => {
  if (!price) return null;

  const color = price > 0 ? "success" : price < 0 ? "danger" : "dark";

  return (
    <span
      className={`fw-bold text-${color}`}
      title={convertNumberToWords(price)}
      dir="ltr"
    >
      {numberSeparate(price)}
    </span>
  );
};

export const ConvertCurrencyToText = ({ price, isCurrency }) => {
  const result = convertNumberToWords(price);

  if (!result) return null;
  return (
    <>
      <span className="font-weight-bold">{result}</span>
      {isCurrency && <Currency className="ml-1" />}
    </>
  );
};

const Currency = ({ className = "", isNormal }) => {
  const currency = "ریال";

  if (isNormal) return <>{currency}</>;
  return <span className={`badge badge-primary ${className}`}>{currency}</span>;
};

export default Currency;
